import {RealtimeEventType} from '@sollapay/enums';
import {useQueryClient} from '@tanstack/react-query';

import {invalidateTrustAccountTeam} from '@/features/trust-accounts/utils/trust-account-invalidations.utils';
import {useRealtimeEvent} from '@/hooks/useRealtimeEvent';

/** Keeps the team tab, header roster, account lists and the create modal's suggestion in sync when an account's team changes — also in the acting user's other tabs. */
export function useMembersRealtimeUpdates(): void {
  const queryClient = useQueryClient();

  useRealtimeEvent(RealtimeEventType.TrustAccountMembersChanged, event => {
    void invalidateTrustAccountTeam(queryClient, event.trustAccountId);
  });
}
